import { RequestsBlock } from './fragments/RequestsBlok';
import { RequestsWrapper } from './styled';

export const RequestsCountries = () => (
  <RequestsWrapper>
    <RequestsBlock />
  </RequestsWrapper>
);
